/* Hover-intent for the Shop mega menu tabs.
   - A tab only switches after the mouse rests on it ~250ms (short delay).
   - While the mouse is heading down toward the open panel, passing tabs are ignored (direction-aware).
   - Clicking a tab still switches instantly. */
(function(){
  if (window.__rjMegaIntent) return; window.__rjMegaIntent = true;
  var DELAY = 250, timer = null, pending = null, pts = [];

  document.addEventListener('mousemove', function(e){
    pts.push({x:e.clientX, y:e.clientY, t:Date.now()});
    if (pts.length > 6) pts.shift();
  }, true);

  function headingDown(){
    var now = Date.now();
    var recent = pts.filter(function(p){ return now - p.t < 150; });   // only movement in the last 150ms
    if (recent.length < 2) return false;                                 // mouse has stopped
    var a = recent[0], b = recent[recent.length-1];
    var dx = b.x - a.x, dy = b.y - a.y;
    return dy > 3 && dy > Math.abs(dx) * 0.5;
  }
  function activate(tab){
    var mega = tab.closest('[data-lux-mega]'); if (!mega) return;
    var idx = tab.getAttribute('data-lux-tab');
    mega.querySelectorAll('[data-lux-tab]').forEach(function(t){
      var on = t.getAttribute('data-lux-tab') === idx;
      t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    mega.querySelectorAll('[data-lux-panel]').forEach(function(p){
      p.classList.toggle('is-active', p.getAttribute('data-lux-panel') === idx);
    });
  }
  function cancel(){ clearTimeout(timer); timer = null; pending = null; }
  function schedule(tab){
    clearTimeout(timer);
    pending = tab;
    timer = setTimeout(function(){
      if (pending !== tab) return;
      if (headingDown()) { schedule(tab); return; }   // still moving down toward the panel: wait
      if (!tab.classList.contains('is-active')) activate(tab);
      pending = null;
    }, DELAY);
  }

  // Intercept the theme's instant mouseenter switch (capture phase runs before the tab's own listener)
  document.addEventListener('mouseenter', function(e){
    var tab = e.target && e.target.closest ? e.target.closest('.lux-mega__tab') : null;
    if (!tab || e.target !== tab || window.innerWidth <= 749) return;
    e.stopPropagation();
    schedule(tab);
  }, true);

  document.addEventListener('mouseleave', function(e){
    if (e.target && e.target.classList && e.target.classList.contains('lux-mega__tab') && pending === e.target) cancel();
  }, true);
})();
